<template>
  <div class="view-wrapper">
    <ViewHeader
      title="Team"
      :isFullViewport="true"
      :hideSectionHomeButton="true"
      :hideRoleTutorial="true"
    >
      <template #actions>
        <!-- <Button
          v-if="canUserManagePlanUsersChannelsSubscriptions"
          label="Add Team Member"
          icon="pi pi-plus-circle"
          @click="shouldShowInviteUser = true"
        /> -->
        <Button
        @click="()=>{
            $emit('complete')
            $router.back()
          }"
          label="Close"
          class="p-button-outlined p-ml-2"
        />
      </template>
    </ViewHeader>
    <ViewMain 
      :isFullViewport="true"
    >
      <div class="plan-settings-modal-content" style="max-width: 100rem; margin: 0 auto;">
        <div class="users-container">
          <p class="plan-settings-instructions">
            Add Team Members to your Plan and manage rights.<br/><br/>
            <template v-if="canUserEditPlanProperties">
              Scroll to the bottom of the list to add a Team Member. Click on the caret icon to the far right of a Team Member's name to change their access and edit rights. View <a class="text-link" target="_blank" href="https://www.annumplanning.com/resources/guides/adding-and-removing-team-members/">detailed instructions</a>.
            </template>
            <template v-else>
              Click on the caret icon to the far right of the Team Member's name to change their role and edit rights. Scroll to the bottom of the list to add a Team Member. <br/>View <a class="text-link" target="_blank" href="https://www.annumplanning.com/resources/guides/adding-and-removing-team-members/">detailed instructions</a>.
            </template>
          </p>
          <ul class="team-table">
            <div v-if="editingUser" class="team-table__edit-overlay">
              <div class="spinner">
                <ProgressSpinner strokeWidth="3" />
              </div>
            </div>
            <li class="team-table__head">
              <span id="firstName">First Name</span>
              <span id="lastName">Last Name</span>
              <span id="email">Email</span>
              <span id="role">Role
                <span
                  v-tooltip.top="roleTooltip"
                  class="pi pi-question-circle p-ml-2 tooltip-color"
                >
                </span>
              </span>
              <span id="budget" v-if="useBudgets && canUserViewBudgets">Budget
                <span
                  v-tooltip.top="budgetTooltip"
                  class="pi pi-question-circle p-ml-2 tooltip-color"
                >
                </span>
              </span>
              <span id="editRights">
                Channel Edit Rights
                <span
                  v-tooltip.top="channelEditRightsTooltip"
                  class="pi pi-question-circle p-ml-2 tooltip-color"
                ></span>
              </span>
              <span id="hiddenTags">
                Profile Tags
                <span
                  v-tooltip.top="profileTagsTooltip"
                  class="pi pi-question-circle p-ml-2 tooltip-color"
                ></span>
              </span>
            </li>

            <li
              class="team-table__item"
              v-for="(userRole, index) of filteredUserRoles"
              :key="userRole.id.intID"
            >
              <PlanSettingsUserDetail
                :key="index"
                :userRole="userRole"
                :viewType="'plan-settings'"
              />
            </li>
          </ul>

<!-- TODO: if !roles.length hide add from account and add user forms -->
          <ul class="team-table add-user-container p-mb-6">
            <li v-if="canUserEditPlanProperties && (!isAddUserFormLocked || (isAddUserFormLocked && newUser.emailAddress !== ''))" class="team-table__item add-user p-ai-end new-user-row">
              <div class="add-user__field" id="firstName">
                <label for="">First Name</label>
                <InputText
                  class="p-inputtext"
                  v-model="newUser.firstName"
                  @change="removeUserId"
                  autocomplete="new-password"
                  :disabled="isAddUserFormLocked"
                />
              </div>
              <div class="add-user__field" id="lastName">
                <label for="">Last Name</label>
                <InputText
                  class="p-inputtext"
                  v-model="newUser.lastName"
                  @change="removeUserId"
                  autocomplete="new-password"
                  :disabled="isAddUserFormLocked"
                />
              </div>
              <div class="add-user__field" id="email">
                <label for="">Email</label>
                <InputText
                  class="p-inputtext"
                  v-model="newUser.emailAddress"
                  @change="removeUserId"
                  autocapitalize="none"
                  autocorrect="off"
                  spellcheck="false"
                  autocomplete="new-password"
                  :disabled="isAddUserFormLocked"
                />
              </div>
              <div class="add-user__field" id="role">
                <label for="">Role
                  <span
                    v-tooltip.top="roleTooltip"
                    class="pi pi-question-circle p-ml-2"
                  >
                  </span>
                </label>
                <Dropdown
                  v-model="newUser.role"
                  :options="roleOptions"
                  optionLabel="title"
                  placeholder="Select"
                  @change="onNewUserRoleChange"
                />
              </div>
              <div
                class="add-user__field col-budget"
                id="budget"
                v-if="useBudgets && canUserViewBudgets"
              >
                <label for="">Budget
                  <span
                    v-tooltip.top="budgetTooltip"
                    class="pi pi-question-circle p-ml-2"
                  >
                  </span>
                </label>
                <Dropdown
                  v-model="newUser.canViewBudget"
                  :options="budgetOptions"
                  optionLabel="name"
                  optionValue="code"
                  :disabled="newUser.role.code.intID === 4"
                />
              </div>
              <div class="add-user__field col-edit-right" id="editRights">
                <label for=""
                  >Channel Edit Rights
                  <span
                    v-tooltip.top="channelEditRightsTooltip"
                    class="pi pi-question-circle p-ml-2"
                  ></span>
                </label>
                <MultiSelect
                  v-model="newUser.channels"
                  :options="channels"
                  dataKey="key"
                  optionLabel="name"
                  placeholder="Select"
                  :disabled="newUser.role.code.intID === 6 || newUser.role.code.intID === 4"
                  :class="allItemsSelectedClassObject"
                >
                  <template #value="slotProps">
                    <template v-if="slotProps.value.length === channels.length">
                      All
                    </template>
                  </template>
                </MultiSelect>
              </div>
              <div class="add-user__field col-edit-right" id="profileTags">
                <Button
                  label="Tags"
                  class=""
                  icon="pi pi-plus"
                  :disabled="!currentPlan.tags.length"
                  @click="() => {
                    shouldShowHiddenTags = !shouldShowHiddenTags
                  }"
                />
              </div>
              <div class="edit-user-buttons">
                <div v-if="!shouldShowSelectAccountUserField">
                  <Button
                    class="p-button-text"
                    icon="pi pi-check"
                    @click="addUser"
                    :disabled="!allowAddUser || !isAddUserFormValid"
                  />
                  <Button
                    class="p-button-text"
                    icon="pi pi-times"
                    @click="cancelAddAccountUser"
                  />
                </div>
                <Button
                  v-else
                  label="Add Team Member"
                  class="p-button-text"
                  icon="pi pi-plus-circle"
                  @click="addUser"
                  :disabled="!allowAddUser || !isAddUserFormValid"
                />
              </div>
            </li>
            <li
              class="team-table__item"
              style="padding-top: 0;"
              v-if="shouldShowSelectAccountUserField && canUserEditPlanProperties && visibleAccountUsers.length"
            >
              <p class="select-from-account-message">View and add Team Members who have seats in the Account but do not have access to this Plan:</p>
              <div class="p-d-flex p-flex-row p-ai-center">
                <Dropdown
                  v-model="selectAccountUserId"
                  :options="visibleAccountUsers"
                  :filter="true"
                  dataKey="key"
                  optionLabel="fullName"
                  optionValue="id"
                  placeholder="Select From Account"
                  filterPlaceholder="Search By Name"
                  @change="selectAccount"
                />
                <Button
                  v-if="shouldShowAddSelectedAccountUserButton"
                  label="Grant Plan Access"
                  class="p-button-text p-ml-4 addUserBtn"
                  icon="pi pi-plus-circle"
                  @click="addSelectedAccountUser"
                />
              </div>
              <p class="select-from-account-message">Account Owners: to remove Team Members in the “Select From Account” list and free up their seats, view our <a href="https://annumplanning.com/resources/guides/adding-and-removing-team-members/#remove">detailed instructions</a>.</p>
            </li>
          </ul>

          <div v-if="shouldShowSeatLimitMessage" class="seat-limit-message">
            <template v-if="currentAccountSeats.isUniversalAccount">
              <h2>You have reached your Account's seat limit.</h2>
            </template>
            <template v-else>
              <h2 v-if="currentAccountSeats.adminRemaining <= 0 && currentAccountSeats.viewerRemaining <= 0">You have reached your Account's seat limit for all seat types.</h2>
              <h2 v-else-if="currentAccountSeats.viewerRemaining > 0">You have reached your Account's seat limit for Admins and Contributors.</h2>
              <h2 v-else-if="currentAccountSeats.adminRemaining > 0">You have reached your Account's seat limit for Viewers.</h2>
            </template>
            <template v-if="canUserEditPlanProperties">
              <p>Admins: Free up seats by clicking on the caret icon to the far right of a Team Member's name and removing them from the Account. Refer to <a class="text-link" href="https://www.annumplanning.com/resources/guides/adding-and-removing-team-members/" target="_blank">our guide</a> for detailed instructions. Contact <a class="text-link" href="mailto:hello@annumplanning.com">hello@annumplanning.com</a> to add more seats to your Account.</p>
            </template>
            <template v-else>
              <p>The Account Owner and Admins listed above, can free up seats by removing team members from the Account.<br/> Deleting team members above will only remove their access to this calendar. Accounts often have more than one calendar.<br/> Refer to <a class="text-link" href="https://www.annumplanning.com/resources/guides/adding-and-removing-team-members/" target="_blank">our guide</a> for detailed instructions. Or contact <a class="text-link" href="mailto:hello@annumplanning.com">hello@annumplanning.com</a> to add more seats to your Account.</p>
            </template>
          </div>

          <div class="user-updates-message">
            <h2>To update a name or email address:</h2>
            <p>Team Members click on the black dot in the bottom left corner of the app and select “Profile” to update your own Profile.  Account Owners select “Account Settings” under the black dot, then click on the pencil icon to the right of the Team Member's name to update their Profile.</p>
          </div>
        </div>
      </div>
    </ViewMain>

    <Dialog header="Profile Tags" :visible.sync="shouldShowHiddenTags" :modal="true">
      <TagList
        :selectedTags="newUser.blockedTags"
        :hasBlockedTags="false"
        :allowSelect="true"
        :allowEdit="false"
        :allowCreate="false"
        :allowList="true"
        :isBlockedTags="true"
        :overridePlan="currentPlan"
        @updateSelection="onNewUserHiddenTagListUpdate"
      />
    </Dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import ViewHeader from '@/components/ViewHeader.vue'
import ViewMain from '@/components/ViewMain.vue'
import Tooltip from 'primevue/tooltip'
import Plan, {PlanType} from '@/models/Plan'
import ID from '@/models/ID'
import AlertMessage, {
  AlertMessageSeverity,
} from '@/models/AlertMessage'
import Role from '@/models/Role'
import UserRole from '@/models/UserRole'
import User from '@/models/User'
import Channel from '@/models/Channel'
import PlanSettingsUserDetail from '@/components/PlanSettingsUserDetail.vue'
import ProgressSpinner from 'primevue/progressspinner'
import {fi} from 'date-fns/locale'
import AccountSeats from '@/models/AccountSeats'
import Tag from '@/models/Tag'
import TagList from './TagList.vue'
import Dialog from 'primevue/dialog/Dialog'

Vue.component('PlanSettingsUserDetail', PlanSettingsUserDetail)
Vue.component('ProgressSpinner', ProgressSpinner)
Vue.component('Dialog', Dialog)

export default Vue.extend({
  name: 'PlanSettingsUsers',
  components: {
    ViewHeader,
    ViewMain,
    TagList,
  },
  directives: {
    tooltip: Tooltip,
  },
  data: () => {
    return {
      shouldShowSelectAccountUserField: true,
      shouldShowAddSelectedAccountUserButton: false,
      selectAccountUserId: {} as ID,
      shouldShowInviteUser: false,
      editingUser: false,
      allowAddUser: true,
      channelEditRightsTooltip: `Assign channel edit rights when you want to ensure Contributors only plan within their designated Channels. When you give a Contributor edit rights to a specific Channel, they can add and edit Tactics in that Channel but can only view Tactics in the other Channels.

        Account Owners and Admins have edit rights for all Channels. Viewers have no Channel edit rights.
        `,
      roleTooltip: `Set each team member's role within the Plan. Every role contains the rights of the roles below it.

        Account Owner
        - Manages subscriptions, seats, and billing
        - One per account, contact Annum to transition to another team member

        Admin
        - Sets up marketing Channels and Tactic Types
        - Enters Tags
        - Manages Team Members
        - Activates Budget feature, sets annual Budget
        - Activates custom Calendars of Interest

        Contributor
        - Adds and edits Initiatives (Campaigns, Promotions, Key Dates, Monthly Themes)
        - Adds and edits Tactics

        Viewer
        - Views and filters data
        `,
      budgetTooltip: `Select whether you would like give Contributors and Viewers the ability to view Budget data in the Plan. Account Owners and Admins can always view Budget data.`,
      profileTagsTooltip: `Customize which tagged Initiatives and Tactics are visible for each team member. Activate the Tags related to the items that you'd like visible. Other options within each Tag category will, as a result, be hidden. Untagged items within the Plans will remain visible.`,
      newUser: {
        firstName: '',
        lastName: '',
        emailAddress: '',
        role: {
          title: '',
          code: new ID(),
        },
        canViewBudget: true,
        channels: [] as Channel[],
        userId: new ID(),
        blockedTags: [] as Tag[],
      },
      budgetOptions: [
        {
          name: 'Hide',
          code: false,
        },
        {
          name: 'View',
          code: true,
        },
      ],
      shouldShowHiddenTags: false,
    }
  },
  computed: {
    canUserEditPlanProperties(): boolean {
      return this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_PLAN_ADMIN
    },
    canUserManagePlanUsersChannelsSubscriptions(): boolean {
      return this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_PLAN_ADMIN
    },
    canUserViewBudgets(): boolean {
      return this.$store.getters.currentUserRole.canViewBudget
    },
    useBudgets(): boolean {
      return this.$store.getters.currentPlan.useBudgets
    },
    channels(): Channel[] {
      return this.$store.getters.currentPlan.channels.filter(
        (channel) => channel.id.intID !== this.currentPlan.id.intID
      )
    },
    roleOptions(): {}[] {
      return this.$store.getters.allRoles
        .filter((role) => {
          // Integration role is a separate seat pool, only assignable by super admins
          if(role.isIntegration){
            if(!this.$store.getters.currentUser.isSuperUser){
              return false
            }
            // Gate on the integration seat pool
            if(this.currentAccountSeats.isIntegrationLimitReached){
              // Only keep when the selected user already holds an integration seat
              return this.selectedCurrentAccountUserHighestRole?.isIntegration ? true : false
            }
            return true
          }
          if(role.level >= 250){
            // Filter out used roles in per-seat accounts
            if(!this.currentAccountSeats.isUniversalAccount){
              // Admin and contributor seats
              if(this.currentAccountSeats.adminRemaining < 1 && role.level <= Role.LEVEL_CONTRIBUTOR){
                if(this.selectedCurrentAccountUserHighestRole?.level <= Role.LEVEL_CONTRIBUTOR && !this.selectedCurrentAccountUserHighestRole?.isIntegration){
                  // User from account with admin/contributor seat
                  return true
                }
                return false
              }
              // Viewer seats
              if(this.currentAccountSeats.viewerRemaining < 1 && role.level === Role.LEVEL_VIEWER){
                if(this.selectedCurrentAccountUserHighestRole?.level === Role.LEVEL_VIEWER){
                  // User from account with viewer seat
                  return true
                }
                return false
              }
              return true
            }
            return true
          }
          return false
        })
        .map((role) => ({
          title: role.title,
          code: role.id,
        }))
    },
    allAccountUsers(): User[] {
      return this.$store.getters.allAccountUsers
    },
    visibleAccountUsers(): User[] {
      return this.allAccountUsers.filter((user)=>{
        if(
          // Check that this user is not current user
          user.id.intID === this.$store.getters.currentUser.id.intID 
          // Check that this user is not already in plan
          || this.currentPlan.userRoles.filter((userRole)=>userRole.userId.intID === user.id.intID).length > 0 
          // Check that this user is unique in the account
          || this.$store.getters.currentAccountUniqueUserRoles.filter((userRole)=>userRole.userId.intID === user.id.intID).length === 0
          ){
          return false
        }
        return true
      })
    },
    selectedCurrentAccountUser(): User {
      const foundUser = this.allAccountUsers.find(
        (user) => user.id.intID === this.selectAccountUserId.intID
      )
      return foundUser ? foundUser : new User()
    },
    selectedCurrentAccountUserHighestRole(): Role {
      return this.$store.getters.allRoles.find((role) => role.id.intID === this.selectedCurrentAccountUser.highestRoleId.intID)
    },
    currentPlan(): Plan {
      return this.$store.getters.currentPlan
    },
    filteredUserRoles(): UserRole[] {
      return this.currentPlan.userRoles.filter((userRole)=>{
        // Filter out account owner role
        if(userRole.roleId.intID === 1){
          return false
        }

        // TODO: temporary fix for Patty appearing in users list on customer plans
        if(this.$store.getters.currentAccount.id.intID !== 1 && userRole.userId.intID === 3){
          return false
        }

        // Hide integration users from non-super-admins
        if(!this.$store.getters.currentUser.isSuperUser){
          const roleForUserRole = this.$store.getters.allRoles.find((role) => role.id.intID === userRole.roleId.intID)
          if(roleForUserRole?.isIntegration){
            return false
          }
        }

        // Add item to list
        return true
      })
    },
    isLeadPlan(): boolean {
      return this.currentPlan.plans.length ? true : false
    },
    currentPlanChannels(): Channel[] {
      return this.currentPlan.channels.filter(
        (channel) => channel.id.intID !== this.currentPlan.initiativeChannel.id.intID && ((this.isLeadPlan && !channel.isNested) || (!this.isLeadPlan && (channel.isLead || channel.isNested)) || (!channel.isLead && !channel.isNested))
      )
    },
    isAddUserFormValid(): boolean {
      return this.newUser.firstName !== '' && this.newUser.lastName !== '' && this.newUser.emailAddress !== '' && this.newUser.role.title !== ''
    },
    currentAccountSeats(): AccountSeats {
      return this.$store.getters.currentAccount.seats
    },
    // Integration seats are a separate pool, so super admins can still add an
    // integration team member once the universal/admin/viewer seats are used up.
    // Mirrors the integration branch of roleOptions above, so the form never
    // opens onto a Role dropdown with nothing in it.
    canAddIntegrationUser(): boolean {
      return this.$store.getters.currentUser.isSuperUser && !this.currentAccountSeats.isIntegrationLimitReached
    },
    isAddUserFormLocked(): boolean {
      return this.currentAccountSeats.isAllLimitsReached && !this.canAddIntegrationUser
    },
    shouldShowSeatLimitMessage(): boolean {
      return this.currentAccountSeats.isAnyLimitReached
    },
    allItemsSelectedClassObject(): object {
      return {'all-items-selected': this.newUser.channels.length === this.channels.length}
    },
  },
  methods: {
    onNewUserHiddenTagListUpdate(updatedList: Tag[]){
      this.newUser.blockedTags = updatedList
    },
    removeUserId() {
      this.newUser.userId = new ID()
    },
    getRoleForId(roleId: ID) {
      return this.$store.getters.allRoles.find(
        (role) => role.id.intID == roleId.intID
      )
    },
    getAccountUserForId(userId: ID): User {
      const thisUser = this.$store.getters.allAccountUsers.find(
        (user) => user.id.intID == userId.intID
      )
      return thisUser ? thisUser : new User()
    },
    getAccountUserForEmail(email: string): User | null {
      const thisUser = this.$store.getters.allAccountUsers.find(
        (user) => user.emailAddress === email
      )
      return thisUser ? thisUser : null
    },
    handleRemoveUserFromPlan(userRole: UserRole, event) {
      this.$confirm.require({
        acceptLabel: 'YES',
        rejectLabel: 'NO',
        target: event.currentTarget,
        message: 'Are you sure?',
        accept: () => {
          this.$store.getters.services.users.deleteUserRole(userRole.id).then(
            () => {
              // Update account and plan to refresh account seats
              this.$store.dispatch('refreshCurrentAccount').then(
                ()=>{
                  this.$store.dispatch('refreshCurrentPlan') 
                }
              )
            },
            (error) => {
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.error,
                summary: 'Error removing user from plan.',
                detail: error,
                life: 3000,
              })
            }
          )
        },
        reject: () => {
          // Remove user rejected
        },
      })
    },
    onNewUserRoleChange(event) {
      // Integration role mirrors Contributor defaults (all channels)
      if(event?.value?.title === 'Integration'){
        if (!this.newUser.channels.length) {
          this.newUser.channels = this.channels
          this.newUser.canViewBudget = true
        }
        return
      }
      switch (event?.value?.code?.intID) {
        case 4:
        case 5:
          // Admin (4) or Contributor (5) role selected
          if (!this.newUser.channels.length) {
            this.newUser.channels = this.channels
            this.newUser.canViewBudget = true
          }
          break
        case 6:
          // Viewer role selected
          this.newUser.channels = []
          this.newUser.canViewBudget = true
          break
        default:
          // Do nothing
          break
      }
    },
    selectAccount() {
      this.shouldShowAddSelectedAccountUserButton = true
    },
    addSelectedAccountUser() {
      this.shouldShowSelectAccountUserField = false
      this.shouldShowAddSelectedAccountUserButton = false
      this.newUser.firstName = this.selectedCurrentAccountUser.firstName
        ? this.selectedCurrentAccountUser.firstName
        : ''
      this.newUser.lastName = this.selectedCurrentAccountUser.lastName
        ? this.selectedCurrentAccountUser.lastName
        : ''
      this.newUser.emailAddress = this.selectedCurrentAccountUser.emailAddress
        ? this.selectedCurrentAccountUser.emailAddress
        : ''
      this.newUser.userId =
        this.selectedCurrentAccountUser.id.intID !== 0
          ? this.selectedCurrentAccountUser.id
          : new ID()
    },
    resetNewUser() {
      this.newUser = {
        firstName: '',
        lastName: '',
        emailAddress: '',
        role: {
          title: '',
          code: new ID(),
        },
        canViewBudget: true,
        channels: [],
        userId: new ID(),
        blockedTags: [],
      }
      this.selectAccountUserId = new ID()
    },
    addUser() {
      const accountUser = this.getAccountUserForEmail(this.newUser.emailAddress.trim())
      if(accountUser && this.currentPlan.userRoles.filter((userRole)=>userRole.userId.intID === accountUser?.id.intID).length > 0){
        Vue.prototype.$toast.add({
          severity: AlertMessageSeverity.error,
          summary: 'A user with this email address already has access to the Plan.',
        })
        return
      }

      const isAddingAccountUser = this.newUser.userId.intID !== 0
      const role = this.$store.getters.allRoles.find(
        (el) => el.id.intID === this.newUser.role.code.intID
      )
      const newUserRole = new UserRole()
      newUserRole.canViewBudget = this.newUser.canViewBudget
      newUserRole.channels = this.newUser.channels.map(
        (channel) => channel.id
      )
      newUserRole.roleId = role.id
      newUserRole.planId = this.currentPlan.id
      newUserRole.accountId = this.$store.getters.currentAccount.id
      if(role.id === 4 || this.newUser.channels.length >= this.currentPlanChannels.length){
        newUserRole.canEditAllChannels = true
      }

      this.allowAddUser = false

      if (isAddingAccountUser) {
        newUserRole.userId = this.newUser.userId
        this.$store.getters.services.users
          .createUserRole(newUserRole)
          .then((newDbUserRole) => {
            this.currentPlan.userRoles.push(newDbUserRole)
            this.currentPlan.userRoleIds.push(newDbUserRole.id)
            this.$store.getters.currentAccount.userRoles.push(newDbUserRole)

            // Update existing User with blockedTags
            const thisUser = this.$store.getters.currentAccount.users.find((user) => user.id.intID === newDbUserRole.userId.intID)
            thisUser.blockedTagIds = [...thisUser.blockedTagIds, ...this.newUser.blockedTags.map((tag) => tag.id)]
            this.$store.getters.services.users.update(thisUser).then(
              ()=>{
                this.resetNewUser()
                this.shouldShowSelectAccountUserField = true
                this.allowAddUser = true

                // Update account and plan to refresh account seats
                this.$store.dispatch('refreshCurrentAccount').then(
                  ()=>{
                    this.$store.dispatch('refreshCurrentPlan') 
                  }
                )
              },
              (error)=>{
                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.error,
                  summary: `Error adding user to plan: ${error}`,
                })
                this.resetNewUser()
                this.shouldShowSelectAccountUserField = true
                this.allowAddUser = true
              }
            )
          },
          (error)=>{
            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.error,
              summary: `Error adding user to plan: ${error}`,
            })
            this.resetNewUser()
            this.shouldShowSelectAccountUserField = true
            this.allowAddUser = true
          })
      } else {
        const newUser = User.fromResponseObject({
          firstName: this.newUser.firstName,
          lastName: this.newUser.lastName,
          emailAddress: this.newUser.emailAddress,
          status: 'pending',
          blockedTags: this.newUser.blockedTags.map((tag) => tag.id.intID),
        })
        this.$store.getters.services.users
          .create(newUser, this.$store.getters.currentAccount.id, this.$store.getters.currentPlan.id)
          .then((newDbUser: User) => {
            this.$store.getters.allAccountUsers.push(newDbUser)
            newUserRole.userId = newDbUser.id
            this.$store.getters.services.users
              .createUserRole(newUserRole)
              .then((newDbUserRole: UserRole) => {
                this.currentPlan.userRoles.push(newDbUserRole)
                this.currentPlan.userRoleIds.push(newDbUserRole.id)
                this.$store.getters.currentAccount.userRoles.push(newDbUserRole)
                this.resetNewUser()
                this.shouldShowSelectAccountUserField = true
                this.allowAddUser = true

                // Update account and plan to refresh account seats
                this.$store.dispatch('refreshCurrentAccount').then(
                  ()=>{
                    this.$store.dispatch('refreshCurrentPlan') 
                  }
                )
              },
              (error)=>{
                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.error,
                  summary: `Error adding new user to plan: ${error}`,
                })
                this.resetNewUser()
                this.shouldShowSelectAccountUserField = true
                this.allowAddUser = true
              })
          },
          (error)=>{
            if(error.message.includes('status code 422') || error.message.includes('status code 409')){
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.error,
                summary: 'This email address is connected to a user who already has a Seat in this Account. Give them access to this Plan by clicking on the Select From Account drop down.',
              })
            }else{
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.error,
                summary: `Error creating user: ${error}`,
              })
            }
            this.allowAddUser = true
          })
      }
    },
    cancelAddAccountUser() {
      this.shouldShowSelectAccountUserField = true
      this.selectAccountUserId = new ID()
      this.resetNewUser()
    },
  },
})
</script>